import React from 'react'
import { useHistory } from 'react-router-dom'

import PropTypes from 'prop-types'
import { Box, Link, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import styles from './styles'

const ActivityAlert = ({ message, color, linkText, linkPath }) => {
  const useStyles = styles(color)
  const classes = useStyles()
  const history = useHistory()

  const handleLinkClick = () => {
    history.push(linkPath)
  }

  return (
    <Box mt={2}>
      <Alert
        variant="standard"
        severity="info"
        classes={{ icon: classes.icon }}
        className={classes.alert}
      >
        <Typography className={classes.message} component="span">
          {message}
          {linkText && (
            <Link
              variant="body1"
              underline="always"
              className={classes.linkInfo}
              onClick={handleLinkClick}
            >
              {linkText}
            </Link>
          )}
        </Typography>
      </Alert>
    </Box>
  )
}

ActivityAlert.propTypes = {
  message: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
}

export default ActivityAlert
